import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as React from 'react';

var arrayStateReducer = function arrayStateReducer(equalityComparer, initialValue) {
  return function (state, action) {
    switch (action.type) {
      case 'push':
        return [].concat(_toConsumableArray(state.filter(function (item) {
          return !equalityComparer(item, action.payload);
        })), [action.payload]);

      case 'pull':
        return state.filter(function (item) {
          return !equalityComparer(item, action.payload);
        });

      case 'clear':
        return initialValue;

      default:
        return state;
    }
  };
};
/** Store an array value in state, and access push, pull, clear methods to interact with that state - all contained within a reducer, meaning that multiple state updates can happen in a single thread without any unusual behaviors */


export var useArrayState = function useArrayState(
/** The initial value of the state */
initialValue) {
  var equalityComparer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
    return a === b;
  };

  var _React$useReducer = React.useReducer(arrayStateReducer(equalityComparer, initialValue), initialValue),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      currentValue = _React$useReducer2[0],
      dispatchAction = _React$useReducer2[1];

  var contains = React.useCallback(function (value) {
    return !!currentValue.find(function (item) {
      return equalityComparer(value, item);
    });
  }, [currentValue, equalityComparer]);
  var push = React.useCallback(function (value) {
    dispatchAction({
      type: 'push',
      payload: value
    });
  }, [currentValue, equalityComparer]);
  var pull = React.useCallback(function (value) {
    dispatchAction({
      type: 'pull',
      payload: value
    });
  }, [currentValue, equalityComparer]);
  var clear = React.useCallback(function () {
    dispatchAction({
      type: 'clear'
    });
  }, [currentValue, equalityComparer]);
  var toggle = React.useCallback(function (value) {
    return contains(value) ? pull(value) : push(value);
  }, [currentValue, equalityComparer]);
  return [currentValue, {
    push: push,
    pull: pull,
    toggle: toggle,
    contains: contains,
    clear: clear
  }];
};
/** Store an array value of objects in a state, with a key used to compare values when removing and adding */

export var useArrayObjectState = function useArrayObjectState(initialValue, key) {
  var equalityComparer = React.useCallback(function (a, b) {
    return a[key] === b[key];
  }, [key]);
  return useArrayState(initialValue, equalityComparer);
};